import React, {useEffect} from "react";
import {Card, CardBody, CardHeader, CardHeaderToolbar, ModalProgressBar,} from "../../../_metronic/_partials/controls";
import OrdersTable from "./OrdersTable";
import {useOrdersUIContext} from "./OrdersUIContext";
import {shallowEqual, useSelector} from "react-redux";
import {getStatuses,getFactors} from "./crud/orderCrud";
import {OrderEdit} from "./order-edit/OrderEdit";
import {useQuery} from "../../../_metronic/_helpers/SearchParams";

export default function OrdersListCmp() {

    const orderContext = useOrdersUIContext();
    const {actionsLoading} = useSelector(
        (state) => ({
            actionsLoading: state.actionsLoading.actionsLoading,
        }),
        shallowEqual
    );

    let query = useQuery();

    useEffect(() => {
        getStatuses().then(response => {
            orderContext.setStatuses(response.data.data);
        })

        getFactors().then(response => {
            orderContext.setFactors(response.data.data);
        })
    }, []);

    useEffect(() => {
        // orderContext.fetchData(query.get("page") ? query.get("page") : 1, query.get("limit") ? query.get("limit") : '');
        orderContext.fetchData();

    }, [query.get("page"), query.get("limit")]);





    return (
        <>
            {actionsLoading && <ModalProgressBar/>}
            <Card>
                <CardHeader title="لیست سفارشات">
                    <CardHeaderToolbar>
                        <button
                            type="button"
                            className="btn btn-warning ml-2"
                            onClick={() => {
                                orderContext.fetchData()
                            }}>
                            بارگزاری مجدد
                        </button>
                    </CardHeaderToolbar>
                </CardHeader>
                <CardBody>
                    {(orderContext.data?.data && orderContext.statuses) &&
                    <OrdersTable
                        data={orderContext.data}
                        activePage={query.get("page") ? query.get("page") : 1}
                    />
                    }

                    {orderContext.openEdit &&
                    <OrderEdit
                        show={orderContext.openEdit}
                        onHide={() => {
                            orderContext.setOpenEdit(false);
                            orderContext.fetchData();
                        }}
                        onSave={() => {
                            orderContext.setOpenEdit(false);
                            orderContext.fetchData()
                        }}
                    />
                    }

                </CardBody>
            </Card>
        </>
    )
}